import FeedbackPage from '@/components/FeedbackPage'
import { ArrowPathIcon } from '@heroicons/react/24/outline'

export default function HabitsIntroPage() {
  return (
    <FeedbackPage
      icon={<ArrowPathIcon className="h-8 w-8 text-white" />}
      headingKey="pages.onboarding.habitsIntro.heading"
      descriptionKey="pages.onboarding.habitsIntro.description"
    />
  )
}
